// src/components/UI/LoadingSpinner.jsx
import React from 'react';

const LoadingSpinner = () => {
  return (
    <div className="flex items-center justify-center min-h-[200px]">
      <div className="relative">
        {/* Spinner principal */}
        <div className="w-12 h-12 rounded-full border-4 border-blue-200 border-t-blue-600 animate-spin"></div>
        {/* Overlay gradient pour effet de profondeur */}
        <div className="absolute inset-0 rounded-full bg-gradient-to-tr from-transparent via-transparent to-slate-900/20"></div>
      </div>
      <span className="sr-only">Chargement...</span>
    </div>
  );
};

export default LoadingSpinner;